export const HOTEL_NAME = process.env.REACT_APP_HOTEL_NAME;
export const HOTEL_SLUG = process.env.REACT_APP_HOTEL_SLUG;
export const HOTEL_LOGO_URL = `./${HOTEL_SLUG}/logo.png`
export const PRIMARY_COLOR = process.env.REACT_APP_PRIMARY_COLOR;
